package de.oevbs.kunde.kundenportal2.model.services.intinscard

import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import de.oevbs.kunde.kundenportal2.validation.KupoValidationMessages
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.errorMessage
import dev.fritz2.validation.validation
import kotlinx.serialization.Serializable

@Lenses
@Serializable
data class IntInsCardInit(
    val firstname: String = "",
    val lastname: String = "",
    val street: String = "",
    val streetNumber: String = "",
    val postalCode: String = "",
    val city: String = "",
    val email: String = "",
    val carContracts: List<CarContract> = emptyList(),
    val selectedContract: CarContract? = null
) {
    companion object {
        val validation = validation<IntInsCardInit, ComponentValidationMessage> { inspector  ->
            val contract = inspector.map(IntInsCardInit.selectedContract())

            if (contract.data == null) {
                add(contract.errorMessage(KupoValidationMessages.EMPTY_SELECT))
            }
        }
    }
}